$( function(){
  
  var video = $('#devVideo')[0];
  
  $(document).on('click', '.icon-playvideo', function (e) {
    $(this).toggleClass('opening open');
    video.play();
    return false;
  });
  $(document).on('click touchstart', '.home-video-embed-wrapper:not( #devVideo )', function (e) {
    $(this).toggleClass('opening open');
    video.pause();
    return false;
  });
  
  
  var devheight = $('.devProListFirst .product-card-figure img').height();
  $('.devProListSecond').height(devheight);
  $('.devProListSecond').css('line-height', devheight  + 'px');
  $('.product.devProListSecond .subcollection-content').css('line-height', devheight  + 'px');
  $('.devProListFirst .product-card-figure').css('padding-bottom', devheight  + 'px');
});

$(window).resize( function(){
  var devheight = $('.devProListFirst .product-card-figure img').height();
  $('.devProListSecond').height(devheight);
  $('.devProListSecond').css('line-height', devheight  + 'px');
  $('.product.devProListSecond .subcollection-content').css('line-height', devheight  + 'px');
  $('.devProListFirst .product-card-figure').css('padding-bottom', devheight  + 'px');
});